import React, { useRef, useState } from "react";
import { QrReader } from "@blackbox-vision/react-qr-reader";

// Leitor de QR Code para o modal "Adicionar Nova Ordem".
// Mesma lógica usada na Listagem de Montagem (QRCodeReaderListaMontagem),
// porém com estilo adaptado para caber dentro do modal Bootstrap.
export default function QRCodeReaderOrdem({ onLeitura }) {
  const [cameraAtiva, setCameraAtiva] = useState(false);
  const lendoRef = useRef(false); // evita múltiplas leituras seguidas

  const handleError = (err) => {
    console.error("Erro na leitura do QR Code:", err);
  };

  const handleScan = (result, error) => {
    if (error) {
      console.debug("QR reader error:", error);
      return;
    }

    if (!result || lendoRef.current) return;

    let texto = null;

    if (typeof result === "string") {
      texto = result;
    } else if (result?.text) {
      texto = result.text;
    } else if (typeof result?.getText === "function") {
      try {
        texto = result.getText();
      } catch (e) {
        console.debug("getText falhou", e);
      }
    }

    if (!texto) return;

    lendoRef.current = true;
    onLeitura(texto.trim());

    setTimeout(() => {
      setCameraAtiva(false);
      lendoRef.current = false;
    }, 300);
  };

  return (
    <div className="mt-3">
      <button
        type="button"
        className={`btn w-100 d-flex align-items-center justify-content-center gap-2 ${cameraAtiva ? "btn-outline-danger" : "btn-outline-success"}`}
        onClick={() => setCameraAtiva((prev) => !prev)}
      >
        <span role="img" aria-label="camera" style={{ fontSize: "1.2em" }}>
          📷
        </span>
        {cameraAtiva ? "Fechar Leitor" : "Ler QR Code"}
      </button>

      {cameraAtiva && (
        <div
          style={{
            position: "relative",
            width: "100%",
            maxWidth: "320px",
            height: "320px",
            margin: "12px auto 0",
            borderRadius: "10px",
            overflow: "hidden",
            boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)",
            backgroundColor: "#000",
          }}
        >
          <QrReader
            onError={handleError}
            onResult={handleScan}
            constraints={{
              facingMode: { ideal: "environment" },
              width: { ideal: 640 },
              height: { ideal: 480 },
            }}
            videoStyle={{ width: "100%", height: "100%", objectFit: "cover" }}
            style={{ width: "100%", height: "100%" }}
            delay={150}
          />
          <div
            aria-hidden="true"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              width: "60%",
              height: "60%",
              transform: "translate(-50%, -50%)",
              boxSizing: "border-box",
              border: "2px dashed rgba(0, 255, 0, 0.5)",
              borderRadius: "8px",
              pointerEvents: "none",
            }}
          />
        </div>
      )}
    </div>
  );
}
